import { UploadImage } from '@/api/common'
import { create_subject, list_subject} from '@/api/subject'


export const Subject = {
  data () {
    return {
      subject_name:'',
      subject_description:'',
      subject_image:null,
      imageDataUrl: null,
      fileName:'',
      addSubjectPopup:false,
      subjectlist:[],
      filesInfo :[],
      file_id:null,
      subjectMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }


    }
  },
  methods:{
    add_subject () {
      this.$validator.validateAll('addSub').then((valid) => {
        if (valid) {
  
  
         /*  const request_parameter = {
            subject_image: this.subject_image,
            subject_name: this.subject_name,
            subject_description: this.subject_description
          } */

          const request_parameter = {
            // subject_image: this.subject_image,
            subject_name: this.subject_name,
            subject_description: this.subject_description,
            file_id:this.file_id
          }        
          this.createSubject(request_parameter)
  
          
          // this.createSubject(request_parameter)
  
          // this.users.unshift({
          //   'name': this.subname,
          //   'desc': this.subdesc,
          //   'image':this.subimage
          // })
        }
      })
    },
    async createSubject (payload) {
      try {
        const customerId =  this.$store.getters.customerId
        // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        // const userId = userInfo.id
        const {data} = await create_subject(customerId, payload)
        // 
        this.addSubjectPopup = false
        // const arrObj = {
        //   subject_description:data.data.subject.subject_description,
        //   subject_image:data.data.subject.subject_image,
        //   subject_name:data.data.subject.subject_name
        // }

        this.fetchSubjectList()

        this.$validator.reset()

  
        this.$vs.notify({
          title:'success',
          text: 'Subject Created successfully',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color:'success'
        })
  
        this.setDefaultValue()
        
      } catch (error) {
        
      }
    },
    setDefaultValue () {
      this.subject_name = ''
      this.subject_description = ''
      this.subject_image = null 
      this.file_id = null
  
    },
    async loadMoreSubjects (getData) {
      if (getData[0].isIntersecting) {
        const ul = getData[0].target.offsetParent
        const scrollTop = getData[0].target.offsetParent.scrollTop

        try {
          const response = await list_subject(this.$store.getters.customerId, this.subjectMeta.current_page + 1)
          this.subjectlist.push(...response.data.data.subjectlist)
          this.subjectMeta = response.data.data.meta
        } catch (e) {
          // 
        }
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async fetchSubjectList () {
      
      const customerId = this.$store.getters.customerId

      try {
        const { data } = await list_subject(customerId, 1)
        // 
        this.subjectlist = data.data.subjectlist
        this.subjectMeta = data.data.meta
        // 
        const all = {
          'id': 0,
          'subject_name': 'All'          
        }
        this.subjectlist.unshift(all)
      } catch (e) {
        
      }
    }
  }
}